import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule } from '@angular/router';

// Pages
import { routes } from './app.routes';

import { AuthGuard } from '@guards/auth.guard';
import { RoleGuard } from '@guards/role.guard';
import { TalentsGuard } from '@guards/talents.guard';
import { ReportingGuard } from '@guards/reporting.guard';
import { ReportingOverviewGuard } from '@guards/reporting-overview.guard';

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  enableTracing: false,
  scrollOffset: [0, 64],
  scrollPositionRestoration: 'enabled',
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  providers: [
    AuthGuard,
    RoleGuard,
    TalentsGuard,
    ReportingGuard,
    ReportingOverviewGuard,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
